import React from "react";
import { PersonGridLayoutProps } from "./PersonGrid";
import styles from "./BiographyPersonGrid.module.scss";
import { imageUrlBuilder } from "../../utils/images";
import WithSpacing from "../Spacing/Spacing";
import Text from "../Text/Text";

const BiographyPersonGrid = ({ people }: PersonGridLayoutProps) => {
  return (
    <div className={styles.root}>
      {people.map(({ name, photo, shortBiography }) => (
        <div className={styles.profile}>
          <img
            width="114"
            height="114"
            src={
              imageUrlBuilder
                .image(photo)
                .quality(90)
                .size(228, 228)
                .fit("fill")
                .bg("fff")
                .url()!
            }
            alt=""
          />
          <WithSpacing>
            <div className={styles.bio}>
              <Text variant="defaultBold" as="h3">
                {name}
              </Text>
              <Text variant="defaultLight">{shortBiography}</Text>
            </div>
          </WithSpacing>
        </div>
      ))}
    </div>
  );
};

export default BiographyPersonGrid;
